import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Spinner, } from 'react-bootstrap';
import TransactionService from '../../../service/TransactionService';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import ObjectUtils from '../../../modules/ObjectUtils';
import TransactionNotes from './TransactionNotes';

class DetailedTransaction extends React.Component {
  constructor(props) {
    super(props);
    const { transaction, } = props;
    this.state = {
      transaction,
      paymentHistoryHeaders: [],
      paymentHistoryRows: [],
      lineItemHeaders: [],
      lineItemRows: [],
      isReady: false,
    };
    this.lastFourKeyExclusions = [ 'paymentHistory', 'lineItems', 'transactionNotes', ];
  }

  componentDidMount() {
    this._mounted = true;
    const { transaction, } = this.props;
    if (transaction.v2_txn_id.length > 0) {
      TransactionService.getTransactionDetail(transaction.v2_txn_id)
        .then((response) => {
          const { data = {}, } = response;
          const { paymentHistory, } = data.transaction;
          const formattedPaymentHistory = [];
          if (paymentHistory) {
            paymentHistory.forEach((item) => {
              formattedPaymentHistory.push({
                ...item,
                timeStamp: new Date(item.timeStamp.$date).toISOString(),
              });
            });
          }

          const paymentHistoryModel = Grid.toModelFromList(formattedPaymentHistory, {
            headerFormatter: value => _.startCase(value.header),
          });

          if (this._mounted) {
            this.setState({
              transaction: data.transaction,
              paymentHistoryHeaders: paymentHistoryModel.headers,
              paymentHistoryRows: paymentHistoryModel.format(formattedPaymentHistory),
              isReady: true,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      TransactionService.getV3TransactionDetail(transaction.v3_txn_id)
        .then((response) => {
          const { data = {}, } = response;
          const lineItems = ObjectUtils.formatStringAsJSONArray(data.v3transaction.lineItems);
          const paymentHistory = ObjectUtils.formatStringAsJSONArray(
            data.v3transaction.paymentHistory
          );
          const formattedPaymentHistory = [];
          paymentHistory.forEach((item) => {
            formattedPaymentHistory.push({
              ...item,
              timeStamp: new Date(item.timeStamp.$date).toISOString(),
            });
          });
          const formattedLineItems = lineItems;
          const lineItemRows = [];
          let lineItemHeaders = [];

          const paymentHistoryModel = Grid.toModelFromList(formattedPaymentHistory, {
            headerFormatter: value => _.startCase(value.header),
          });

          lineItemHeaders = ObjectUtils.toLargestKeySet(formattedLineItems).map(lineItem => ({
            display: _.startCase(lineItem),
            value: lineItem,
          }));

          formattedLineItems.map((lineItem) => {
            const item = lineItem;
            item.amount = lineItem.amount.value;

            if (lineItem.fees !== undefined) {
              if (lineItem.fees.PAYIT_FEE !== undefined) {
                item.fees.PAYIT_FEE = lineItem.fees.PAYIT_FEE.value;
              }
              if (lineItem.fees.AGENCY_FEE !== undefined) {
                item.fees.AGENCY_FEE = lineItem.fees.AGENCY_FEE.value;
              }
              if (lineItem.fees.CREDIT_CARD !== undefined) {
                item.fees.CREDIT_CARD = lineItem.fees.CREDIT_CARD.value;
              }
              if (lineItem.fees.DEBIT_CARD !== undefined) {
                item.fees.DEBIT_CARD = lineItem.fees.DEBIT_CARD.value;
              }
              if (lineItem.fees.ACH !== undefined) {
                item.fees.ACH = lineItem.fees.ACH.value;
              }
            }

            return item;
          });

          formattedLineItems.forEach((lineItem) => {
            const values = Object.values(lineItem);

            lineItemRows.push({
              value: values,
              raw: lineItem,
            });
          });

          if (this._mounted) {
            this.setState({
              transaction: data.v3transaction,
              paymentHistoryHeaders: paymentHistoryModel.headers,
              paymentHistoryRows: paymentHistoryModel.format(formattedPaymentHistory),
              lineItemHeaders,
              lineItemRows,
              isReady: true,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  formatTransaction(transaction) {
    const copy = { ...transaction, };
    return copy;
  }

  render() {
    const {
      transaction,
      paymentHistoryHeaders = [],
      paymentHistoryRows = [],
      lineItemHeaders = [],
      lineItemRows = [],
      isReady,
    } = this.state;
    const formatTransaction = this.formatTransaction(transaction);

    let items;

    if (isReady) {
      items = VerticalLabelList.toList(formatTransaction, {
        displayFormatter: (value) => {
          const formattedValue = value.split('_').join(' ');
          return _.startCase(formattedValue);
        },
      });
    }

    return (
      <>
        {(() => {
          if (isReady) {
            return (
              <>
                <FieldSet title="Transaction Summary" style={{ maxHeight: '400px', }}>
                  <VerticalLabelList items={items} exclusions={this.lastFourKeyExclusions} />
                </FieldSet>
                <>
                  <FieldSet title="Line Items">
                    <Grid headers={lineItemHeaders} rows={lineItemRows} />
                  </FieldSet>
                </>
                <FieldSet title="Payment History">
                  <Grid headers={paymentHistoryHeaders} rows={paymentHistoryRows} />
                </FieldSet>
                <TransactionNotes
                  transactionNotes={ObjectUtils.formatStringAsJSONArray(
                    transaction.transactionNotes
                  )}
                />
              </>
            );
          }
          return (
            <div className="row justify-content-center">
              <Spinner animation="border" />
            </div>
          );
        })()}
      </>
    );
  }
}

DetailedTransaction.defaultProps = {};

DetailedTransaction.propTypes = {
  transaction: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedTransaction;
